import { gql } from '@apollo/client';

export const DELETE_SYMPTOMS = gql`
  mutation deleteSymptoms($appointmentId: Float!) {
    deleteSymptoms(appointmentId: $appointmentId)
  }
`;
